import { c as _c } from "react/compiler-runtime";
import { FaroTextMenuButton } from "@components/common/faro-text-menu-button";
import { Text, Checkmark2Icon, Divider, ListSubheader, MenuItem } from "@flat-ui";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Box, Grid, Stack } from "@mui-wrapper";
import { useAccountSettingsLayout } from "@pages/account-settings/account-settings-layout/account-settings-layout-utils";
import { PALETTE_VARS } from "@styles/palette-vars";
import { DEFAULT_TEXT_FONT_SIZE, DEFAULT_TEXT_FONT_WEIGHT } from "@styles/common-styles";
/** Header margin when there is a divider */
const MARGIN_TOP_WITH_DIVIDER = 2.5;

/** A dropdown to show for account settings */
export function AccountSettingsDropdown(t0) {
  const $ = _c(28);
  const {
    shouldShowDescriptionInTitle: t1,
    items,
    selectedItem,
    onClickHandler
  } = t0;
  const shouldShowDescriptionInTitle = t1 === undefined ? false : t1;
  const {
    isHoverSupported,
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const {
    accountSettingsFontSize,
    accountSettingsFontWeight
  } = useAccountSettingsLayout();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== accountSettingsFontSize || $[2] !== accountSettingsFontWeight) {
    t3 = {
      fontSize: accountSettingsFontSize,
      fontWeight: accountSettingsFontWeight
    };
    $[1] = accountSettingsFontSize;
    $[2] = accountSettingsFontWeight;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== selectedItem.label || $[5] !== t3) {
    t4 = <Box sx={t3}>{selectedItem.label}</Box>;
    $[4] = selectedItem.label;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isScreenSmOrSmaller || $[8] !== selectedItem.description || $[9] !== shouldShowDescriptionInTitle) {
    t5 = shouldShowDescriptionInTitle && !isScreenSmOrSmaller && <Box sx={{
      fontSize: DEFAULT_TEXT_FONT_SIZE,
      fontWeight: DEFAULT_TEXT_FONT_WEIGHT
    }}>{selectedItem.description}</Box>;
    $[7] = isScreenSmOrSmaller;
    $[8] = selectedItem.description;
    $[9] = shouldShowDescriptionInTitle;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <Grid container={true} sx={t2}>{t4}{t5}</Grid>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const ButtonTitle = t6;
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      width: "100%"
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== isHoverSupported) {
    t8 = isMenuOpen => ({
      color: isMenuOpen ? "primary.main" : "text.primary",
      width: "100%",
      textOverflow: "ellipsis",
      justifyContent: "space-between",
      "& .MuiButton-icon": {
        "& svg": {
          width: "16px",
          height: "16px"
        }
      },
      "&:not(&:focus)": {
        borderBottom: isHoverSupported ? "none" : `1px solid ${PALETTE_VARS.divider}`,
        "& .MuiButton-icon": {
          visibility: isHoverSupported ? "hidden" : "visible"
        },
        "&:hover": {
          backgroundColor: "action.hover",
          color: "primary.main",
          "& .MuiButton-icon": {
            visibility: "visible"
          }
        }
      },
      "&:focus": {
        borderBottom: `2px solid ${PALETTE_VARS.primary.main}`,
        color: "primary.main"
      }
    });
    $[15] = isHoverSupported;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== items || $[18] !== onClickHandler || $[19] !== selectedItem.value) {
    let t10;
    if ($[21] !== onClickHandler || $[22] !== selectedItem.value) {
      t10 = (item, index) => {
        const isSelectedItem = item.value === selectedItem.value;
        if (item.isHeader) {
          return <ListSubheader key={index} sx={{
            p: 1.5
          }}>{index !== 0 && <Divider />}<Text component="div" variant="labelS" sx={{
              mt: index === 0 ? 1 : MARGIN_TOP_WITH_DIVIDER
            }}>{item.label}</Text></ListSubheader>;
        }
        return <MenuItem data-my-value={item.value} key={item.value} value={item.value} selected={isSelectedItem} onClick={event => {
          if (event.currentTarget.dataset.myValue) {
            onClickHandler(event.currentTarget.dataset.myValue);
          }
        }}><Box sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            whiteSpace: "normal"
          }}><Stack direction="row" sx={{
              gap: 1.5,
              alignItems: "baseline"
            }}><Text variant="bodyM" sx={{
                color: isSelectedItem ? "primary.main" : "text.primary"
              }}>{item.label}</Text><Text variant="bodyS" sx={{
                color: isSelectedItem ? "primary.main" : "text.secondary"
              }}>{item.description}</Text></Stack>{isSelectedItem && <Checkmark2Icon sx={{
              color: "primary.main",
              width: "18px",
              height: "18px"
            }} />}</Box></MenuItem>;
      };
      $[21] = onClickHandler;
      $[22] = selectedItem.value;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    t9 = items.map(t10);
    $[17] = items;
    $[18] = onClickHandler;
    $[19] = selectedItem.value;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[24] !== ButtonTitle || $[25] !== t8 || $[26] !== t9) {
    t10 = <Stack sx={t7}><FaroTextMenuButton buttonTitle={ButtonTitle} isMenuWidthEqualToButton={true} buttonSx={t8}>{t9}</FaroTextMenuButton></Stack>;
    $[24] = ButtonTitle;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}